// Auto-generated cornerstone translation for fi.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:46:35.177359+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Hevosenhallinta-sovellus: paras valinta 2026 | EquiSight",
      description: "Vertaile hevosenhallinta-sovelluksia omistajalle, tallille ja hevoskasvatukselle. Tutustu, miksi EquiSight on täydellinen sovellus hevosellesi.",
      keywords: [
        "hevosenhallinta-sovellus",
        "tallinhallinnan sovellus",
        "hevosten lokikirja-sovellus",
        "sovellus useamman hevosen hallintaan",
        "tamman tiineys-sovellus",
        "hevoskasvatuksen sovellus",
        "paras hevosenhallinta-sovellus",
      ],
    },
    hero: {
      eyebrow: "Valintaopas · hevosenhallintaohjelmisto",
      breadcrumbLabel: "Hevosenhallinta-sovellus",
      title: "Hevosenhallinta-sovellus: täydellinen valintaopas omistajille, talleille ja hevoskasvattajille.",
      intro: "Ei pelkkä ominaisuuslista — rehellinen vertailu, valintaopas ja katsaus siihen, mitä hevosenhallinta-sovelluksen täytyy oikeasti osata vuonna 2026. Yhdelle hevoselle, kokonaiselle tallille tai hevoskasvatuksellesi.",
      pills: [
        {
          icon: "Users",
          label: "Omistajille",
        },
        {
          icon: "Building2",
          label: "Talleille",
        },
        {
          icon: "Baby",
          label: "Kasvattajille",
        },
        {
          icon: "Share2",
          label: "Tiimeille",
        },
      ],
      ctas: [
        {
          label: "Aloita ilmaiseksi 1 hevosella",
          href: "#start",
          primary: true,
        },
        {
          label: "Vertailutaulukkoon",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miksi hevosenhallinta-sovellus on yhä tärkeämpi.",
      lead: "Hevosenhallinta on käytännössä hajanaista: WhatsApp, kalenteri, Excel, puhelimen kuvat, paperinen passi, irrallisia laskuja ja suullisia sopimuksia. Jo yhdellä hevosella hankalaa. Useammilla hevosilla, kasvatuksessa tai yhteisessä hoidossa syntyy aukkoja, unohtuneita tapaamisia ja riitoja.",
      items: [
        "Missäköhän se rokotuspäivämäärä taas oli?",
        "Kuka maksoi kengittäjälle?",
        "Mitä tammaa pitää tarkastaa tänään?",
        "Luiko valmentaja viime viikon ohjeen ollenkaan?",
        "Tallensiko minä sen valokuvan varmasti?",
        "Pitääkö tallissa roikkuva ruokintaohjelma vielä paikkansa?",
      ],
    },
    what: {
      title: "Mikä on hevosenhallinta-sovellus?",
      lead: "Hevosenhallinta-sovellus on pohjimmiltaan digitaalinen sähköinen rekisteri hevoskohtaisesti. Ei hajanaisia muistiinpanoja, vaan yksi paikka terveydelle, harjoittelulle, ruokinnalle, asiakirjoille, suunnittelulle, muistutuksille, kustannuksille, kuville, videoille ja jaetulle pääsylle. Kaikki hevosen ympärillä olevat katsovat samaa, ajantasaista tietoa.",
      targetGroupsTitle: "Kenelle hevosenhallinta-sovellus on tarkoitettu?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Yksityinen omistaja",
          body: "Yksi hevonen, yksi rekisteri — terveys, suunnittelu ja historia taskussasi.",
        },
        {
          icon: "Users",
          title: "Useamman hevosen omistaja",
          body: "Erilliset profiilit, erillinen suunnittelu, koko tiimin yhteinen tehtävälista.",
        },
        {
          icon: "Building2",
          title: "Täysihoitotalli ja ratsastuskoulu",
          body: "Omistajan pääsy, hoito-ohjeet, yhteinen kalenteri ja tehtävät.",
        },
        {
          icon: "Baby",
          title: "Hevoskasvatus",
          body: "Tamman kiima, tiineys, oriitiedot, sukutaulu ja varsan kehitys.",
        },
        {
          icon: "Target",
          title: "Valmentajat",
          body: "Hevoskohtainen näkymä, harjoitusten kirjaus, tavoitteiden asettaminen, videoiden analysointi.",
        },
        {
          icon: "ClipboardList",
          title: "Ammattilaiset",
          body: "Kengittäjä, hammaslääkäri, fysioterapeutti tai eläinlääkäri — työskentelevät saman rekisterin pohjalta.",
        },
      ],
    },
    criteria: {
      title: "Mitä hyvältä hevosenhallinta-sovellukselta vaaditaan?",
      lead: "Sovellus ei ole vain kaunis — sen täytyy toimia käytännössä päivittäin. Viisi osa-aluetta, jotka eivät saa puuttua vuoden 2026 valinnasta.",
      items: [
        {
          icon: "FileText",
          title: "Hevoskohtainen rekisteri",
          body: "Tiedot, ikä, rotu, passitieto, omistaja, talli, kuvat ja asiakirjat — kaikki yhdistetty yhteen hevosprofiiliin.",
        },
        {
          icon: "Heart",
          title: "Terveys ja hoito",
          body: "Rokotukset, loishäätö, kengittäjä, hammaslääkäri, eläinlääkäri, hoidot, lääkitys ja automaattiset muistutukset ennen eräpäivää.",
        },
        {
          icon: "Activity",
          title: "Harjoittelu ja edistyminen",
          body: "Harjoitusten kirjaus, muistiinpanot, videot, kilpailutulokset, tavoitteet ja edistyminen lajikohtaisesti tai hevoskohtaisesti.",
        },
        {
          icon: "Apple",
          title: "Ruokinta ja hallinta",
          body: "Ruokintaohjelmat, lisäravinteet, karkearehu, paino, kuntoluokka ja päivittäinen rutiini, jonka tallin täytyy tietää.",
        },
        {
          icon: "Share2",
          title: "Jakaminen muiden kanssa",
          body: "Pääsy omistajalle, hoitajalle, valmentajalle, tallinpitäjälle tai ammattilaiselle — roolikohtaisella oikeudenhallinnalla.",
        },
        {
          icon: "Calendar",
          title: "Suunnittelu ja muistutukset",
          body: "Jaettu kalenteri tehtävineen, automaattiset muistutukset ja vahvistukset, jotta mikään ei lipsu läpi.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs muut hevosenhallinta-sovellukset.",
      lead: "Markkinoilla on useita vaihtoehtoja: Stalmanager, LogMyHorse, EquineM ja Happie Horse. Kullakin on omat vahvuutensa. Asetamme eniten kysytyt ominaisuudet rinnakkain — rehellisesti ja julkisesti saatavilla olevan tiedon perusteella.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Ilmainen aloitus",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Useampi hevonen",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Terveysrekisteri",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Harjoittelu ja edistyminen",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ruokinta ja lisäravinteet",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Suunnittelu ja muistutukset",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hevoskohtaiset asiakirjat",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Jakaminen tiimille ja oikeudet",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Kasvatusmoduuli (täydellinen)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tamman kiima",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tiineyden suunnittelu ja kaikututkimukset",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Varsan kehitys",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ammattilaisten integrointi",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach-näkemykset",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sopii omistajalle",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Sopii kasvattajalle",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sopii tallille/ratsastuskoululle",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Vertailu perustuu julkisesti saatavilla oleviin ominaisuuksiin tammikuussa 2026. Kilpailijat ovat myös hyviä työkaluja; EquiSight on rakennettu yhdistämään kaikki moduulit yhteen sovellukseen.",
    },
    why: {
      title: "Miksi EquiSight on erilainen.",
      lead: "Lokikirja rekisteröi. EquiSight yhdistää hevostenhallinnan, harjoittelun, ruokinnan, terveyden, kilpailut, ammattilaiset ja kasvatuksen yhteen moderniin sovellukseen — ja menee askeleen pidemmälle tarjoamalla näkemyksiä.",
      points: [
        {
          icon: "Heart",
          title: "Yksi sovellus hevosen koko elämälle",
          body: "Varsaksi syntymästä urheiluhevoseksi, siitostammaksi tai eläköityväksi hevoseksi. Rekisteri kasvaa hevosesi mukana — mikään ei katoa matkalla.",
        },
        {
          icon: "Sparkles",
          title: "Ei vain dataa, myös kaavoja",
          body: "EquiCoach yhdistää kehityksen, toistuvat vaivat, harjoittelun ja ruokinnan — jotta näet signaalit ajoissa, et vain irrallisia ilmoituksia.",
        },
        {
          icon: "Share2",
          title: "Rakennettu yhteistyötä varten",
          body: "Omistaja, tallinpitäjä, valmentaja, kengittäjä ja muut ammattilaiset työskentelevät saman hevosrekisterin pohjalta — roolin mukaisilla oikeuksilla.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Erikoisala · hevoskasvatus",
      title: "Hevosenhallinta kasvattajille.",
      lead: "Monet kilpailijat mainitsevat kasvatuksen yhdellä rivillä. EquiSight rakensi täydellisen kasvatusmoduulin — koska kasvattaja harvoin on yleisen sovelluksen pääkäyttäjä, mutta tarvitsee suunnittelua enemmän kuin kukaan muu.",
      items: [
        "Tamman kiiman päivittäinen seuranta",
        "Siemennyspäivämäärä ja oriitiedot",
        "Tiineystarkastus kaikututkimuksilla",
        "Odotettu varsomispäivä ja varoitukset",
        "Varsan kehitys kuukausittain",
        "Sukutaulu ja polveutuminen",
        "Muistiinpanot tammittain",
        "Yhteenveto kaikista tiineistä tammoista",
      ],
      ctaLabel: "Tutustu kasvatusmoduuliin",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Erikoisala · talli ja ratsastuskoulu",
      title: "Hevosenhallinta useammalle hevoselle ja täysihoitotalleille.",
      lead: "Useammalla hevosella kyse on vähemmän datasta ja enemmän viestinnästä. Jokaisella omistajalla on omat toiveensa, rutiininsa, ruokintasopimuksensa ja lääketieteelliset huomionsa. Jokaisen työntekijän on päästävä niihin käsiksi ilman etsimistä.",
      cards: [
        {
          t: "Hevoset omistajittain",
          d: "Jokainen omistaja näkee vain oman hevosensa/hevosensa.",
        },
        {
          t: "Hoito-ohjeet",
          d: "Näkyvissä tallille hevoskohtaisesti.",
        },
        {
          t: "Yhteinen kalenteri",
          d: "Kengittäjä, eläinlääkäri ja kilpailut yhdessä näkymässä.",
        },
        {
          t: "Tehtävälista",
          d: "Jaetaan työntekijöille vahvistuksineen.",
        },
        {
          t: "Omistajan pääsy",
          d: "Asiakkaat näkevät hevosensa omasta sovelluksestaan.",
        },
        {
          t: "Hätäyhteystiedot",
          d: "Aina löydettävissä stressitilanteessa tallissa.",
        },
      ],
      ctaLabel: "Tutustu ratsastuskoulumoduuliin",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "WhatsAppista, Excelistä ja valkotaulusta EquiSightiin.",
      lead: "Konkreettisesti: näin päivittäinen hevosenhallintasi muuttuu.",
      rows: [
        {
          before: "WhatsApp-ryhmät",
          after: "Jäsennellyt muistiinpanot hevoskohtaisesti",
        },
        {
          before: "Excel-taulukot",
          after: "Reaaliaikainen hevosrekisteri historiatietoineen",
        },
        {
          before: "Valkotaulu tallissa",
          after: "Jaettu suunnittelu puhelimessasi",
        },
        {
          before: "Irralliset kuvat kameralla",
          after: "Media yhdistettynä hevosteesi",
        },
        {
          before: "Suulliset sopimukset",
          after: "Tehtävät ja muistutukset vahvistuksineen",
        },
        {
          before: "Paperinen passi hukassa",
          after: "Asiakirjat aina käsillä",
        },
      ],
    },
    helper: {
      title: "Mikä hevosenhallinta-sovellus sopii sinulle?",
      lead: "Vastaa näihin 5 kysymykseen ja saat rehellisen suosituksen — vaikka se ei aina olisikaan EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Onko sinulla yksi vai useampi hevonen?",
          options: [
            {
              label: "Yksi hevonen",
              score: 1,
            },
            {
              label: "2–5 hevosta",
              score: 2,
            },
            {
              label: "Yli 5 hevosta",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Hallinnoidko asiakkaiden tai muiden henkilöiden hevosia?",
          options: [
            {
              label: "En, vain omiani",
              score: 0,
            },
            {
              label: "Joskus — perheen tai tuttavien hevosia",
              score: 1,
            },
            {
              label: "Kyllä, ammatillisesti (talli / ratsastuskoulu)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Haluatko seurata kasvatusta ja tiineyttä?",
          options: [
            {
              label: "Ei koske minua",
              score: 0,
            },
            {
              label: "Joskus — satunnainen kasvatus",
              score: 1,
            },
            {
              label: "Kyllä, olen (tai tulen olemaan) kasvattaja",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Teetkö yhteistyötä valmentajan, hoitajan tai ammattilaisen kanssa?",
          options: [
            {
              label: "En, teen kaiken itse",
              score: 0,
            },
            {
              label: "Kyllä, yhden henkilön kanssa",
              score: 1,
            },
            {
              label: "Kyllä, usean henkilön kanssa",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Haluatko vain rekisteröidä vai myös saada näkemyksiä?",
          options: [
            {
              label: "Vain rekisteröidä",
              score: 1,
            },
            {
              label: "Rekisteröidä ja suunnitella",
              score: 2,
            },
            {
              label: "Rekisteröidä, suunnitella ja saada näkemyksiä",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Yksinkertainen lokikirja riittää — ja kasvaa mukanasi.",
          body: "Yhdelle hevoselle ilman jaettua hoitoa sopii mikä tahansa hevosenhallinta-sovellus. EquiSight alkaa ilmaiseksi yhdellä hevosella, joten et ota riskiä. Jos myöhemmin haluat lisätä hevosia, valmentajan tai kasvatuksen, kaikki on jo valmiina.",
          cta: "Aloita ilmaiseksi 1 hevosella",
        },
        mid: {
          title: "EquiSight sopii hyvin tilanteeseesi.",
          body: "Sinulla on useita tarpeita (useampia hevosia, yhteistyötä tai näkemyksiä). Useimmat kilpailijat kattavat 1–2 moduulia; EquiSight yhdistää ne yhteen sovellukseen ilman erillisten työkalujen yhdistämistä.",
          cta: "Katso, mitä EquiSight voi tehdä",
        },
        high: {
          title: "EquiSight on loogisin valinta.",
          body: "Tilanteesi yhdistää useamman hevosen, yhteistyön, kasvatuksen ja/tai näkemykset. Juuri tässä EquiSight tekee eron — ei hajanaisia työkaluja, vaan yksi hevosrekisteri kaikelle ja kaikille hevosen ympärillä.",
          cta: "Aloita ilmaiseksi EquiSightillä",
        },
      },
    },
    faqTitle: "Usein kysytyt kysymykset hevosenhallinta-sovelluksista",
    faq: [
      {
        q: "Mikä on paras hevosenhallinta-sovellus?",
        a: "Paras hevosenhallinta-sovellus riippuu tilanteestasi. Pelkkään yksinkertaiseen lokikirjaan sopii useampi sovellus. Jos haluat yhdistää terveyden, harjoittelun, ruokinnan, asiakirjat, kasvatuksen, suunnittelun ja yhteistyön, EquiSight on rakennettu täydelliseksi ratkaisuksi, jossa kaikki kokoontuu yhteen rekisteriin.",
      },
      {
        q: "Voinko hallita useampaa hevosta yhdessä sovelluksessa?",
        a: "Kyllä. Hyvän hevosenhallinta-sovelluksen täytyy tukea useampaa hevosta, mukaan lukien omistajat, hoitajat, rutiinit, asiakirjat, tapaamiset ja muistutukset hevoskohtaisesti. EquiSight on suunniteltu tähän ensimmäisestä koodirivistä lähtien — hevoset ovat yksittäisiä rekistereitä, eivät rivejä listassa.",
      },
      {
        q: "Sopiiko EquiSight myös hevoskasvattajille?",
        a: "Kyllä. EquiSight voidaan konfiguroida kasvatustoiminnoilla, kuten tamman kiimalla, siemennyspäivämäärällä, tiineystarkastuksella, oriitiedoilla, sukutaululla, odotetulla varsomispäivällä ja varsan kehityksellä. Juuri tällä alueella useimmat kilpailevat sovellukset eivät juuri tue tai eivät tue lainkaan.",
      },
      {
        q: "Voinko jakaa tiedot valmentajalleni tai kengittäjälleni?",
        a: "Kyllä. EquiSightin tavoitteena on, että asiaankuuluva tieto voidaan jakaa turvallisesti hevosen ympärillä olevien ihmisten kanssa — valmentaja, kengittäjä, hammaslääkäri, eläinlääkäri, fysioterapeutti, hoitaja tai omistaja. Jokainen henkilö saa vain ne oikeudet, jotka ovat tarpeen hänen roolissaan.",
      },
      {
        q: "Miksi ei käyttäisi vain WhatsAppia tai Exceliä?",
        a: "WhatsApp ja Excel toimivat niin kauan kuin asiat pysyvät yksinkertaisina. Heti kun sinulla on useampia hevosia, tapaamisia, asiakirjoja, hoitoja, omistajia tai kasvatusdata, virheistä tulee alttiita: tieto leviää, etsiminen vie aikaa ja suulliset sopimukset katoavat. Hevosenhallinta-sovellus kokoaa kaiken yhteen hevoskohtaisesti automaattisine muistutuksineen.",
      },
      {
        q: "Mitä EquiSight maksaa?",
        a: "Voit aloittaa ilmaiseksi yhdellä hevosella. Jos haluat hallita useampia hevosia, aktivoida kasvatuksen tai antaa ammattilaisille pääsyn, saatavilla on edullisia Premium-paketteja. Katso ajantasaiset vaihtoehdot hinnastosivulta.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Jalostusohjelma hevosille: kattava vertailu 2026",
      description: "Vertaile hevosten jalostusohjelmistoja: tamman kiima, tiineys, oriivalinta ja varsat. Tutustu siihen, miksi EquiSight on täydellisin jalostussovellus.",
      keywords: [
        "jalostusohjelma hevonen",
        "tamman kiima -sovellus",
        "tamman tiineys -sovellus",
        "varsan rekisteröinti -sovellus",
        "kantakirja-sovellus hevonen",
        "astutussuunnittelu hevonen",
        "oriivalinta-sovellus",
      ],
    },
    hero: {
      eyebrow: "Valintatyökalu · jalostusohjelmisto",
      breadcrumbLabel: "Jalostusohjelmisto",
      title: "Jalostusohjelmisto hevosille: kattava vertailu vuodelle 2026.",
      intro: "Siitostamma ansaitsee enemmän kuin tavallinen hevosenhallintasovellus. Vertaile tunnetuimpien työkalujen jalostusominaisuuksia, tutustu siihen, mitä sinun todella kannattaa arvioida, ja valitse tietoisesti ohjelmisto, joka sopii talliisi — suureen tai pieneen.",
      pills: [
        {
          icon: "Baby",
          label: "Tamman kiima",
        },
        {
          icon: "Heart",
          label: "Tiineystarkistus",
        },
        {
          icon: "Sparkles",
          label: "Varsan kehitys",
        },
        {
          icon: "FileText",
          label: "Kantakirja",
        },
      ],
      ctas: [
        {
          label: "Aloita ilmaiseksi jalostusmoduulilla",
          href: "#start",
          primary: true,
        },
        {
          label: "Siirry vertailutaulukkoon",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miksi tavallinen hevosenhallintasovellus ei riitä jalostukseen.",
      lead: "Useimmat hevosurheilusovellukset on suunniteltu yhdelle urheilu- tai harrastushevoselle. Jalostuksella on aivan oma rytminsä: kiima, siemennys, tiineystarkistukset, ultraäänet, varsalenteri, sukupuu ja myynti. Yksi Excel menettää hallinnan jo kahden kauden jälkeen — ja useamman tamman kanssa ote katoaa kokonaan.",
      items: [
        "Milloin Bonitan viimeinen kiima olikaan?",
        "Mikä ori on suunniteltu astumaan ensi kaudella?",
        "Onko 21 päivän ultraääni jo aikataulutettu?",
        "Mitkä vuoden 2024 varsoista on jo myyty?",
        "Missä on sukupuukaavio äidinpuolen isoisiin asti?",
        "Missä ovat DNA-näytteet ja passiporttitiedot?",
      ],
    },
    what: {
      title: "Mikä on hevosten jalostusohjelmisto?",
      lead: "Jalostusohjelmisto on erikoistunut dossier jokaiselle tammalle ja oriille, yhdistettynä jalostuskalenteri, tiineyssuunnittelu, varsanrekisteröinti ja sukupuunäkymä. Ei yleinen hevospäiväkirja, vaan työkalu, joka ymmärtää jalostussyklin: ensimmäisestä kiimasta vieroitukseen.",
      targetGroupsTitle: "Mille jalostajalle jalostusohjelmisto on tarkoitettu?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Harrastusjalostaja (1–3 tammaa)",
          body: "Yksi tai kaksi astutusta vuodessa — selkeä yleiskatsaus ilman Excel-akrobatiaa.",
        },
        {
          icon: "Building2",
          title: "Pieni talli (4–10 tammaa)",
          body: "Jalostuskausisuunnitelma, johon sisältyy kiima, siemennys, tiineystarkistukset ja varsadossier.",
        },
        {
          icon: "Users",
          title: "Ammatillinen talli (10+)",
          body: "Useita työntekijöitä, oriivalinta per tamma, myynti ja markkinointi.",
        },
        {
          icon: "Target",
          title: "Oriintalli",
          body: "Tilaushistoria, siemennestetilastot ja kalenteri per ori.",
        },
        {
          icon: "Heart",
          title: "Alkionsiirto",
          body: "Luovuttaja- ja vastaanottajatamma yhdistettynä dossierina, alkionsiirtokalenteri.",
        },
        {
          icon: "ClipboardList",
          title: "Kantakirjarekisteröinti",
          body: "DNA-näytteet, passiporttiasiakirjat ja sukupuutiedot.",
        },
      ],
    },
    criteria: {
      title: "Mitä hyvän jalostusohjelmiston tulee sisältää?",
      lead: "Kaikki hevossovelluksen 'jalostusominaisuudet' eivät ole samanlaisia. Viisi osa-aluetta, joilla jalostajat menettävät paljon aikaa — ja joissa ohjelmisto tekee todellisen eron.",
      items: [
        {
          icon: "Calendar",
          title: "Tamman kiima ja kiimakierto",
          body: "Päivittäinen kirjaus, ovulaatioennuste, syklikohtainen eteneminen ja automaattiset muistutukset.",
        },
        {
          icon: "Heart",
          title: "Siemennys ja tiineystarkistus",
          body: "Astutus- ja siemennyspäivät, orin tiedot, 14 päivän ultraääni, 21 päivän ultraääni, 60 päivän ultraääni ja sukupuolen määritys.",
        },
        {
          icon: "Baby",
          title: "Varsan kehitys",
          body: "Syntymätiedot, painokäyrä, madotusaikataulu, vieroitushetki, passiporttirekisteröinti.",
        },
        {
          icon: "FileText",
          title: "Sukupuu ja paperit",
          body: "Sukupuunäkymä 4–5 sukupolveen, DNA, passitunnukset ja kantakirjastatus.",
        },
        {
          icon: "Target",
          title: "Oriivalinta ja paritus",
          body: "Suodatus lajin, linjojen, orin tietojen ja historiallisen menestyksen mukaan — ei vain sen perusteella, mitä oriin omistaja mainostaa.",
        },
        {
          icon: "Share2",
          title: "Yhteistyö eläinlääkärin/siementäjän kanssa",
          body: "Ultraäänet, näytteet ja tilannetiedot jaetaan suoraan tammiasi hoitavan klinikan kanssa.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. muut jalostusohjelmistot.",
      lead: "Suomalaisessa haussa jalostusohjelmistoille näkyy usein yleisiä hevossovelluksia, jotka mainitsevat jalostuksen vain ohimennen. Vertailemme rehellisesti, millä työkaluilla on todella kattava jalostusprosessi.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Ilmainen aloitus",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Tamman kiimakierron kirjaus",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Siemennyspäivä + ori",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultraäänet ja tiineystarkistus",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Arvioitu varsomispäivä",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Varsadossier (paino/kasvu)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Sukupuu 4–5 sukupolveen",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA ja passiporttirekisteröinti",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Oriivalinta / paritus",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Alkionsiirto / ET",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Monen tamman yleiskatsaus",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobiili (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Jakaminen eläinlääkärin kanssa",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integroitu yleiseen dossieriin",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Varsojen myynti ja markkinointi",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Vertailu perustuu julkisesti saatavilla oleviin ominaisuuksiin tammikuussa 2026. EquineGenie on vahva jalostuksessa, mutta heikompi mobiilissa ja yleisessä hevostenhallinnassa. EquiSight yhdistää molemmat.",
    },
    why: {
      title: "Miksi EquiSight palvelee jalostajia eri tavalla.",
      lead: "Monet jalostajat käyttävät erillistä jalostusohjelmistoa ja erillistä hevostenhallinasovellusta. EquiSight yhdistää molemmat — ilman sovellusten välillä vaihtamista tai tietojen kaksinkertaista syöttämistä.",
      points: [
        {
          icon: "Heart",
          title: "Siitostamma on myös tavallinen hevonen",
          body: "Siitostammalla on jalostuskausi ja tavallinen hevosdossier — terveys, rokotukset, kavionhoito. Yksi sovellus, kaikki moduulit.",
        },
        {
          icon: "Sparkles",
          title: "Ennakoiva eikä reaktiivinen",
          body: "Kiimakiertoennuste, tiineyden välietappimuistutukset ja varsalenteri — automaattisesti omien tietojesi pohjalta.",
        },
        {
          icon: "Share2",
          title: "Kaikki jalostuksen ympärillä",
          body: "Siementäjä, oriintalli, eläinlääkäri, ostaja, kantakirja — kaikilla pääsy oikeilla oikeuksilla.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Lajikohtaisesti · kiimasta vieroitukseen",
      title: "Mitä jalostusosio EquiSightissa sisältää.",
      lead: "Jokaiselle tammalle saat täydellisen jalostusossieriin, joka on yhdistetty hänen tavalliseen hevosdossieriinsa.",
      items: [
        "Päivittäinen kiimakiertokirjaus ennusteella",
        "Siemennys/astutus + orin tiedot",
        "Ultraääniaikajana (14/21/60 päivää + sukupuoli)",
        "Tiineyden välietapit automaattisilla muistutuksilla",
        "Arvioitu varsomispäivä ja valmistautuminen",
        "Varsadossier syntymästä alkaen",
        "Sukupuu isoisovanhempiin asti klikkausnavigaatiolla",
        "DNA-näyte, passiportti, kantakirjastatus",
        "Myyntiputki kiinnostuneilla",
        "Oriivalintahistoria per tamma",
      ],
      ctaLabel: "Tutustu jalostusmoduuliin",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Koko tallille",
      title: "Yleiskatsaus useista tammoista ja oreista.",
      lead: "Kun fokkaat yli 2–3 tammaa, kaikkien kiimakiertojen ja tiineyksien hallinta on ratkaisevan tärkeää.",
      cards: [
        {
          t: "Kiimakiertokojelauta",
          d: "Kaikki tammat rinnakkain, kiimakiertovaihe ja seuraava toimenpide.",
        },
        {
          t: "Tiineysputki",
          d: "Mitkä tammat ovat missäkin tiineyden välietapissa?",
        },
        {
          t: "Varsalenteri",
          d: "Odotetut syntymät kuukausittain, logistiikka sovitettuna niihin.",
        },
        {
          t: "Oriportfolio",
          d: "Omat orit tai vakiosiementäjät tilaushistorioineen.",
        },
        {
          t: "Sukupuukaavio",
          d: "Esi-isäanalyysi useiden sukupolvien ja linjojen yli.",
        },
        {
          t: "Myyntikojelauta",
          d: "Mitkä varsat on myyty, varattu tai vielä saatavilla.",
        },
      ],
    },
    beforeAfter: {
      title: "Excelistä ja kalenterista EquiSightin jalostukseen.",
      lead: "Konkreettisesti: näin jalostuskautesi muuttuu.",
      rows: [
        {
          before: "Kiima irrallisessa muistiinpanossa",
          after: "Päivittäinen kirjaus ennusteella",
        },
        {
          before: "Ultraäänet WhatsAppilla siementäjälle",
          after: "Jaettu dossier valokuvineen",
        },
        {
          before: "Tiineyspäivä kalenterissa",
          after: "Automaattiset välietappimuistutukset",
        },
        {
          before: "Varsanpassi laatikoissa",
          after: "Asiakirja yhdistettynä varsan profiiliin",
        },
        {
          before: "Sukupuu paperilla",
          after: "Klikattava sukupuu 4–5 sukupolveen",
        },
        {
          before: "Myynti-ilmoitus Marktplaatsissa",
          after: "Myyntiputki kiinnostuneisten listalla",
        },
      ],
    },
    helper: {
      title: "Mikä jalostusohjelmisto sopii sinulle?",
      lead: "5 kysymystä sen selvittämiseksi, tarvitsetko kattavan jalostussovelluksen vai riittääkö harrastustyökalu.",
      questions: [
        {
          id: "mares",
          q: "Kuinka monta siitostammaa hallinnoit?",
          options: [
            {
              label: "1 tamma",
              score: 1,
            },
            {
              label: "2–5 tammaa",
              score: 2,
            },
            {
              label: "Yli 5 tammaa",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Kuinka usein jalostet vuodessa?",
          options: [
            {
              label: "Satunnaisesti (muutaman vuoden välein)",
              score: 0,
            },
            {
              label: "Joka vuosi 1–2 astutusta",
              score: 2,
            },
            {
              label: "Joka vuosi 3+ astutusta",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Miten siemennetään/astutetaan?",
          options: [
            {
              label: "Luonnollinen astutus",
              score: 1,
            },
            {
              label: "Keinosiemennys tuoreella/jäähdytetyllä spermalla",
              score: 2,
            },
            {
              label: "Alkionsiirto tai pakastettu sperma",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Teetkö yhteistyötä eläinlääkärin tai siementäjän kanssa?",
          options: [
            {
              label: "Yksi vakiohenkilö",
              score: 1,
            },
            {
              label: "Useita klinikoita",
              score: 2,
            },
            {
              label: "Kansainvälinen verkosto",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Mitä seuraat tällä hetkellä?",
          options: [
            {
              label: "Excel tai paperi",
              score: 1,
            },
            {
              label: "Yleinen hevostenhallinasovellus",
              score: 2,
            },
            {
              label: "Ei mitään järjestelmällistä",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Harrastustyökalu tai Excel riittää — mutta EquiSight on silti kätevä.",
          body: "Yhdelle tammalle luonnollisella astutuksella muutaman vuoden välein laaja jalostusmoduuli on ylimitoitettu. EquiSight käynnistyy ilmaiseksi ja aktivoit jalostusmoduulin vain sille vuodelle, jolloin astutat — ilman pakollista päivitystä.",
          cta: "Aloita ilmaiseksi",
        },
        mid: {
          title: "EquiSightin jalostusmoduuli on oikea työkalu.",
          body: "Sinulla on useita tammoja tai useita jalostusmenetelmiä — siihen yleiset hevossovellukset eivät ole rakennettuja. EquiSight yhdistää jalostuksen ja yleisen hoidon, joten sinun ei tarvitse vaihdella kahden työkalun välillä.",
          cta: "Tutustu jalostusmoduuliin",
        },
        high: {
          title: "EquiSight on rakennettu tallillesi.",
          body: "Useita tammoja, alkionsiirto tai pakastettu sperma, kansainvälinen tiimi — useimmat työkalut eivät selviä tästä. EquiSight skaalautuu tallin tasoon ilman, että kasaat lisälisenssejä.",
          cta: "Keskustele kanssamme tallisuunnitelmasta",
        },
      },
    },
    faqTitle: "Usein kysyttyjä kysymyksiä jalostusohjelmistoista",
    faq: [
      {
        q: "Mikä on paras jalostusohjelmisto hevosille?",
        a: "Yhdelle tammalle ilman monimutkaisia jalostusmenetelmiä monet työkalut riittävät. Kun on 2–3 tammaa tai enemmän, käytetään keinosiemennystä tai alkionsiirtoa tai tehdään yhteistyötä eläinlääkärin ja kantakirjan kanssa, täydellinen jalostusmoduuli on välttämätön. EquiSight yhdistää jalostuksen ja yleisen hevostenhoidon yhdessä sovelluksessa, jolloin sinun ei tarvitse vaihdella.",
      },
      {
        q: "Mitkä jalostusominaisuudet todella tarvitsen?",
        a: "Vähintään: kiimakiertokirjaus, astutus-/siemennystiedot, tiineystarkistuksen välietapit ja varsadossier. Valinnaisia mutta tehokkaita: sukupuunäkymä, oriivalinta-arkisto, DNA/passiportti ja myyntiputki.",
      },
      {
        q: "Voiko EquiSight ennustaa tamman kiimakierron?",
        a: "Kyllä. EquiSight käyttää aiempia kiimakiertotietoja ennustetun ovulaation näyttämiseen, jotta voit ajoittaa siemennyksen tai astutuksen oikeaan hetkeen — ilman päivittäistä arvaailua.",
      },
      {
        q: "Toimiiko EquiSight myös alkionsiirtoon?",
        a: "Kyllä. Luovuttaja- ja vastaanottajatamma saavat yhdistetyt dossierit, alkionsiirtokalenterin ja jaetut välietapit klinikan kanssa. Näin et menetä aikajanaa monimutkaisessa alkionsiirtoprosessissa.",
      },
      {
        q: "Voinko tuoda olemassa olevat jalostustietoni?",
        a: "Voit syöttää kiimakierto-, astutus- ja varsatiedot manuaalisesti tai eränä CSV-tiedoston kautta. Aktiivisille jalostustalleille autamme kertaluonteisessa migraatiossa, jos sinulla on tietoja usealta kaudelta.",
      },
      {
        q: "Miten jaan dossierin eläinlääkärini tai siementäjäni kanssa?",
        a: "Jokaiselle henkilölle annetaan roolin mukainen käyttöoikeus: eläinlääkäri, siementäjä, oriintalli tai kantakirjatoimihenkilö. Jokainen näkee vain roolilleen tarpeelliset tiedot — täyttä käyttöoikeutta ei tarvita.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Talliohjelma: kattava vertailu ja valintaopas 2026",
      description: "Vertaile talliohjelimstoja tuntien, ratsastajien, hevosten ja hallinnon näkökulmasta. Löydä sinun tallillesi tai täyshoitotallille sopiva sovellus.",
      keywords: [
        "talliohjelma",
        "tallinhallinnan sovellus",
        "tallin hallinto-ohjelma",
        "tuntien suunnittelu talli",
        "täyshoitotallin ohjelma",
        "ratsastajan hallinto",
        "hevosten hallinto talli",
      ],
    },
    hero: {
      eyebrow: "Valintaopas · talliohjelma",
      breadcrumbLabel: "Talliohjelma",
      title: "Talliohjelma: kattava valintaopas talleille ja täyshoitotalleille.",
      intro: "Tuntien suunnittelu, ratsastajahallinto, hevostenhallinta, laskutus ja viestintä — hyvä talliohjelma kokoaa kaiken yhteen. Vertaile tunnetuimpia vaihtoehtoja ja löydä omalle tallillesi sopiva ratkaisu.",
      pills: [
        {
          icon: "Calendar",
          label: "Tuntien suunnittelu",
        },
        {
          icon: "Users",
          label: "Ratsastajat ja asiakkaat",
        },
        {
          icon: "Heart",
          label: "Hevosten hoito",
        },
        {
          icon: "CreditCard",
          label: "Laskutus",
        },
      ],
      ctas: [
        {
          label: "Pyydä demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Siirry vertailutaulukkoon",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miksi hajanaiset työkalut hidastavat tallin toimintaa.",
      lead: "Useimmat tallit toimivat tilkkutäkkimäisesti: tuntien suunnittelu valkotaululla, ratsastajien rekisteröinti Excelissä, laskutus erillisessä ohjelmassa, hevosten hoito WhatsAppissa ja omistajien yhteydenpito henkilökohtaisilla viesteillä. Kiireisenä viikkona syntyy tuplavarauksia, unohtuneita laskuja tai hevosia, jotka eivät tiedä kuka niitä ratsastaa.",
      items: [
        "Kuka on nyt Jasminin tunnilla?",
        "Kuka ratsastaja ei ole vielä maksanut maaliskuulta?",
        "Mitä hevosta ei saa käyttää tällä viikolla?",
        "Keitä ovat oppilaiden hätäyhteyshenkilöt?",
        "Onko Stardusdin omistaja saanut kengityssepän laskun?",
        "Mikä hevonen on missä karsinassa?",
      ],
    },
    what: {
      title: "Mikä on talliohjelma?",
      lead: "Talliohjelma yhdistää tuntien suunnittelun, ratsastajahallinnon, hevostenhallinnon, laskutuksen ja viestinnän yhteen työkaluun. Ei Excel-akrobatiaa tai WhatsApp-viidakkoa, vaan yksi paikka jossa talli toimii ja omistajat sekä ratsastajat pysyvät ajan tasalla.",
      targetGroupsTitle: "Mille yritystyypille talliohjelma on tarkoitettu?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Pieni talli (1–15 hevosta)",
          body: "Erityisesti tuntien suunnittelu ja maksut — hallinto ilman päänsärkyä.",
        },
        {
          icon: "Users",
          title: "Keskikokoinen talli (15–40 hevosta)",
          body: "Useita ohjaajia, tuntien suunnittelu + hevosaikataulu + ratsastajahallinto.",
        },
        {
          icon: "ClipboardList",
          title: "Suuri ratsastus- ja täyshoitotalli (40+)",
          body: "Täysi toiminta mukaan lukien laskutus, rehun suunnittelu ja kengityssepän aikataulutus.",
        },
        {
          icon: "Heart",
          title: "Täyshoitotalli",
          body: "Omistajaportaali, yksilölliset hoito-ohjeet, jaettu kalenteri.",
        },
        {
          icon: "Target",
          title: "Estehyppy-harjoitustalli",
          body: "Kilpailujen suunnittelu, hevoskohtainen valmennus, asiakasviestintä.",
        },
        {
          icon: "FileText",
          title: "Hevosalan yrittäjät",
          body: "Yhdistelmä tunteja + täyshoito + klinikka + kauppa — kaikki yhdestä järjestelmästä.",
        },
      ],
    },
    criteria: {
      title: "Mitä hyvän talliohjelman tulee täyttää?",
      lead: "Kaunis sovellus ei merkitse mitään, jos työntekijät eivät halua käyttää sitä. Viisi käytännöllistä kriteeriä, jotka ratkaisevat onnistumisen ja turhautumisen välisen eron.",
      items: [
        {
          icon: "Calendar",
          title: "Monitasoinen tuntien suunnittelu",
          body: "Aloittelija/edistynyt, koulu/hyppy, hevosyhdistykset ja ohjaajien kalenterit — kaikki nähtävissä vierekkäin.",
        },
        {
          icon: "Users",
          title: "Ratsastajahallinto",
          body: "Profiilit, taso, tilaus, tuntikortti ja perheenjäsenlinkit nuorille ratsastajille.",
        },
        {
          icon: "Heart",
          title: "Hevosaikataulu",
          body: "Mitä hevosta käytetään kuinka usein, lepo-, vamma- ja kiima-ajat huomioiden.",
        },
        {
          icon: "CreditCard",
          title: "Laskutus ja tilaukset",
          body: "Kuukausittaiset tilaukset, tuntikortit, yksittäiset tunnit ja automaattinen suoraveloitus.",
        },
        {
          icon: "Share2",
          title: "Omistajaportaali (täyshoitotalli)",
          body: "Omistajat näkevät hevosensa omasta sovelluksesta — kalenteri, kulut, kengitysseppä ja muistiinpanot ilman soittelua.",
        },
        {
          icon: "Bell",
          title: "Viestintä ja muistutukset",
          body: "Automaattiset tuntimuistutukset, maksuhuomautukset, kengityssepän ilmoitukset — ilman WhatsApp-viestejä.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs muut talliohjelmat.",
      lead: "Monet talliohjelmistot ovat vahvoja tuntien suunnittelussa tai laskutuksessa, mutta harvoin hevostenhoidossa ja omistajien viestinnässä samanaikaisesti. Vertailemme ne rehellisesti rinnakkain.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Ilmainen aloitus / kokeilujakso",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Tuntien suunnittelu",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Useita ohjaajia",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ratsastajahallinto",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hevosaikataulu",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hevostenhoito (rokotukset/kengitysseppä)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tuntikortti / tilaus",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Verkkomaksut",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automaattinen laskutus",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Omistajaportaali (täyshoito)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kengitysseppä/eläinlääkäri-integraatio",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS-muistutukset",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobiili (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Kilpailujen suunnittelu",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sopii täyshoitotallille",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Vertailu perustuu julkisesti saatavilla oleviin ominaisuuksiin tammikuussa 2026. Stalmanager on vahva hallinnossa, EquiSight erottuu täyshoitotallin prosessissa + hevostenhoidossa + omistajaportaalissa.",
    },
    why: {
      title: "Miksi EquiSight on erilainen talleille ja täyshoitotalleille.",
      lead: "EquiSight menee pidemmälle kuin pelkkä tuntisuunnittelija. Näemme tallin kokonaisvaltaisena toimintana: hevoset, ihmiset, viestintä ja raha — kaikki riippuvat toisistaan.",
      points: [
        {
          icon: "Heart",
          title: "Hevonen keskiössä, ei kalenteri",
          body: "Jokaisella hevosella on oma dossieri. Tuntisuoritteet, terveys, kengitysseppä ja kilpailut yhdellä aikajanalla — ei kolmessa erillisessä työkalussa.",
        },
        {
          icon: "Share2",
          title: "Omistajat ajan tasalla ilman soittelua",
          body: "Täyshoitotallin omistajilla on oma näkymä: kulut, suunnittelu, valokuvat ja muistiinpanot — säästää 5–10 puhelua viikossa.",
        },
        {
          icon: "Bell",
          title: "Automaattinen viestintä",
          body: "Tuntimuistutus, rokotusmuistutus, lasku — automaattisesti, sovelluksen/sähköpostin/SMS:n kautta. Ei enää joukkueviestiWhatsAppia.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Täyshoitotallille",
      title: "Mitä täyshoitotalli saa EquiSightiltä.",
      lead: "Täyshoitotalleilla on ainutlaatuisia haasteita, joita tavalliset talliohjelmistot eivät ratkaise.",
      cards: [
        {
          t: "Omistajaportaali",
          d: "Jokainen omistaja näkee vain omat hevosensa, kalenterinsa ja kulunsa.",
        },
        {
          t: "Hoito-ohjeet hevoskohtaisesti",
          d: "Rehu, karkearehu, lisäravinteet, loimi-aikataulu — nähtävissä tallille.",
        },
        {
          t: "Jaettu kalenteri",
          d: "Kengitysseppä, eläinlääkäri ja omistajien vierailut yhdessä näkymässä.",
        },
        {
          t: "Kulutusmaksut hevoskohtaisesti",
          d: "Kuivike, rehu ja väkirehu veloitetaan omistajittain.",
        },
        {
          t: "Hevosen hätäyhteystiedot",
          d: "Omistaja, eläinlääkäri ja kengitysseppä aina tallin saatavilla.",
        },
        {
          t: "Laidunhallinta",
          d: "Mitkä hevoset menevät laitumelle, lepoon tai kuntoutukseen?",
        },
      ],
    },
    beforeAfter: {
      title: "Valkotaulusta ja Excelistä EquiSightiin.",
      lead: "Konkreettisesti: näin tallin työviikko muuttuu.",
      rows: [
        {
          before: "Valkotaulu tuntien suunnittelussa",
          after: "Reaaliaikainen suunnittelu ohjaajittain",
        },
        {
          before: "Excel ratsastajista ja tuntimuistiinpanoista",
          after: "Asiakkuuksien hallinta tuntihistorialla",
        },
        {
          before: "WhatsApp omistajille",
          after: "Omistajaportaali heidän hevoselleen",
        },
        {
          before: "Kuukausittainen suoraveloitus manuaalisesti",
          after: "Automaattinen laskutus + iDEAL",
        },
        {
          before: "Hevostenhoito paperisella ilmoitustaululla",
          after: "Hoito-ohjeet hevoskohtaisesti, jaettuina",
        },
        {
          before: "Suullinen sopimus kengityssepän kanssa",
          after: "Kengityssepän aikataulu vahvistuksineen",
        },
      ],
    },
    helper: {
      title: "Mikä talliohjelma sopii sinulle?",
      lead: "5 kysymystä selvittääksesi, onko EquiSight oikea alusta tallillesi tai täyshoitotallillesi.",
      questions: [
        {
          id: "size",
          q: "Kuinka monta hevosta sinulla on yrityksessäsi?",
          options: [
            {
              label: "Alle 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Yli 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Mikä on päätoimintasi?",
          options: [
            {
              label: "Pääasiassa tuntien opettaminen",
              score: 1,
            },
            {
              label: "Täyshoitotalli (hevoset täysihoidossa)",
              score: 3,
            },
            {
              label: "Yhdistelmä tunteja ja täyshoitoa",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Kuinka monta ohjaajaa sinulla on?",
          options: [
            {
              label: "Vain minä itse",
              score: 1,
            },
            {
              label: "2–3 ohjaajaa",
              score: 2,
            },
            {
              label: "4 tai enemmän",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Miten hoidat laskutuksesi tällä hetkellä?",
          options: [
            {
              label: "Manuaalisesti (Word/Excel)",
              score: 3,
            },
            {
              label: "Erillinen kirjanpito-ohjelma",
              score: 2,
            },
            {
              label: "Integroitu tuntisuunnitteluohjelmaan",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Miten viestit omistajien kanssa?",
          options: [
            {
              label: "Henkilökohtaisesti / WhatsApp",
              score: 3,
            },
            {
              label: "Sähköposti + WhatsApp",
              score: 2,
            },
            {
              label: "Omistajaportaali ohjelmassa",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Kevyt työkalu tai Excel voi riittää toistaiseksi — mutta EquiSight kasvaa mukanasi.",
          body: "Pienelle oppitunteja tarjoavalle yritykselle, jossa on yksi ohjaaja ja vähän täyshoitoa, ei laajaa ohjelmistopakettia heti tarvita. EquiSight alkaa ilmaiseksi ja kasvaa tallisi mukana — ei migraatiovaivaa muutaman vuoden päästä.",
          cta: "Aloita ilmaiseksi",
        },
        mid: {
          title: "EquiSight on looginen päivitys tallillesi.",
          body: "Useita ohjaajia, yhdistelmä tunteja ja täyshoitoa, tai laskutus joka on nyt erillään — EquiSight yhdistää ne yhdeksi työnkuluksi. Erityisesti omistajaportaali vähentää paljon ad hoc -viestintää.",
          cta: "Pyydä demo",
        },
        high: {
          title: "EquiSight on rakennettu sinun mittakaavaasi.",
          body: "Täyshoitotalli + tunnit + useita ohjaajia on juuri se, missä EquiSight erottuu perinteisistä talliohjelmistoista. Omistajaportaali ja hevostenhoidon integraatio säästävät viikoittain tunteja hallintoa ja viestintää.",
          cta: "Varaa demo tallillesi",
        },
      },
    },
    faqTitle: "Usein kysytyt kysymykset talliohjelmistoista",
    faq: [
      {
        q: "Mikä on paras talliohjelma?",
        a: "Pelkään tuntien suunnitteluun on useita hyviä vaihtoehtoja. Kun tarvitset täyshoitotallin, useita ohjaajia tai hevostenhoidon seurantaa, EquiSight on kattavin ratkaisu — ei työkalujen jongleerausta, kaikki yhdessä paikassa.",
      },
      {
        q: "Voinko tuoda olemassa olevat asiakkaat ja tunnit järjestelmään?",
        a: "Kyllä. Asiakastiedot ja tuntiaikataulut voi tuoda CSV-tiedostona. Autamme aktiivisia talleja kertaluonteisessa migraatiossa, jotta sinun ei tarvitse syöttää 200 ratsastajaa manuaalisesti.",
      },
      {
        q: "Toimiiko se myös täyshoitotallille ilman tunteja?",
        a: "Kyllä. Täyshoitotallitila poistaa tunnit käytöstä ja keskittyy omistajaportaaliin, rehun ja hoidon suunnitteluun, kengityssepän aikataulutukseen sekä kustannusten jakamiseen hevoskohtaisesti.",
      },
      {
        q: "Voivatko ratsastajat ilmoittautua ja maksaa itse?",
        a: "Kyllä. Ratsastajat voivat omalta tililtään nähdä avoimet tunnit, ilmoittautua, maksaa lukukausimaksut iDEAL-palvelulla ja ostaa tuntikortteja.",
      },
      {
        q: "Entä hevos- ja omistajatietojen tietosuoja?",
        a: "Jokaisella henkilöllä on rooli (omistaja, ratsastaja, ohjaaja, työntekijä). Kullakin roolilla näkyy vain se, mitä tarvitaan. Omistajat näkevät vain oman hevosensa, ratsastajat vain omat tuntinsa.",
      },
      {
        q: "Voiko EquiSight yhdistää kirjanpito-ohjelmistooni?",
        a: "Kyllä, integraatiot Exact-, Moneybird- ja e-Boekhouden-ohjelmistoihin ovat saatavilla. Laskut siirtyvät tällöin automaattisesti kirjanpitoon.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Valmentajasovellus hevoselle: vertailu ja valintaopas valmentajille 2026",
      description: "Vertaile valmentajasovelluksia hevoselle ja ratsastajalle: harjoitusloki, video, tavoitteet, protokolla-analyysi ja asiakashallinta. Löydä oikea työkalu valmentajille.",
      keywords: [
        "valmentajasovellus hevonen",
        "instruktiivisovellus",
        "hevosen harjoitussovellus",
        "ratsastajan valmennussovellus",
        "harjoituspäiväkirja hevonen",
        "koulurataprotokolla-analyysi",
        "hevosvalmentajan ohjelmisto",
      ],
    },
    hero: {
      eyebrow: "Valintaopas · valmentajaohjelmisto",
      breadcrumbLabel: "Valmentajasovellus",
      title: "Valmentajasovellus hevoselle: kattava valintaopas instruktoreille ja valmentajille.",
      intro: "Valmentaja tai instruktori jongleeraa yhdistelmillä, tunneilla, videoilla, tavoitteilla ja kilpailuilla. Vertaile parhaita valmentajasovelluksia hevosihmisille ja valitse alusta, joka kasvaa mukanasi vielä 2026:kin.",
      pills: [
        {
          icon: "Target",
          label: "Tavoitteet & suunnittelu",
        },
        {
          icon: "Video",
          label: "Videoanalyysi",
        },
        {
          icon: "TrendingUp",
          label: "Edistyminen",
        },
        {
          icon: "Users",
          label: "Asiakkaat/yhdistelmät",
        },
      ],
      ctas: [
        {
          label: "Aloita ilmaiseksi valmentajana",
          href: "#start",
          primary: true,
        },
        {
          label: "Vertailutaulukkoon",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miksi WhatsApp-valmennus haittaa valmentajia.",
      lead: "Useimmat valmentajat käyttävät irrallisia työkaluja: WhatsApp viestintään, muistikirja tunneille, YouTube tai WeTransfer videoille ja Excel kilpailutuloksille. Viidellä ratsastajalla se toimii. Kahdellakymmenellä ratsastajalla tietoa katoaa, tavoitteet unohtuvat ja yksilöllinen kehitys karkaa käsistä.",
      items: [
        "Mikä on Anoukin tavoite tällä kaudella?",
        "Minkä videon lähetin Bramille viime kuussa?",
        "Onko Lara nähnyt viimeisimmän kilpailunsa protokolla-analyysin?",
        "Kuinka usein mikäkin yhdistelmä harjoittelee viikossa?",
        "Onko Stardustin omistaja lukenut harjoitusohjeen?",
        "Milloin annoin viimeksi palautetta vaihtelevasta impulssista?",
      ],
    },
    what: {
      title: "Mikä on valmentajasovellus hevoselle ja ratsastajalle?",
      lead: "Valmentajasovellus yhdistää valmennuksen CRM:n (yhdistelmät, tunnit, tavoitteet), hevoskohtaisen harjoitusloki, videopalautteen, kilpailusuunnittelun ja protokolla-analyysin. Ei enää irrallisia WhatsApp/YouTube/Excel-työkaluja, vaan yksi alusta, jossa valmentaja ja ratsastaja työskentelevät yhdessä.",
      targetGroupsTitle: "Mille valmentajatyypille tämä on tarkoitettu?",
      targetGroups: [
        {
          icon: "Target",
          title: "Koulurattainstruktori",
          body: "Skannaa protokolla, yhdistä tuomareiden kommentit harjoitustavoitteisiin, seuraa edistymistä.",
        },
        {
          icon: "Activity",
          title: "Esteiden valmentaja",
          body: "Rata-suunnittelu, kierrospalaute, estekorkeiden hallinta hevoskohtaisesti.",
        },
        {
          icon: "Award",
          title: "Moniottelun valmentaja",
          body: "Kolme lajia, kolme suunnitelmaa – kaikki näkyvillä rinnakkain.",
        },
        {
          icon: "TrendingUp",
          title: "Suorituskyvyn valmentaja (urheilu)",
          body: "EPI-seuranta, kilpailut, tavoitteet — huippu-urheilijoille ja heidän tiimeilleen.",
        },
        {
          icon: "Users",
          title: "Tallin instruktori",
          body: "Ryhmätunnit + yksilöllinen valmennus yhdessä sovelluksessa.",
        },
        {
          icon: "Heart",
          title: "Harrastevalmentaja",
          body: "Ratsastusterapia, aloittelijat, omistajat joilla on yksi hevonen.",
        },
      ],
    },
    criteria: {
      title: "Mitä hyvältä valmentajasovellukselta vaaditaan?",
      lead: "Valmentaminen on ihmistyötä, mutta oikea työkalu tekee sinusta 30–50 % tehokkaamman ja auttaa ratsastajia kehittymään myös tuntien välissä.",
      items: [
        {
          icon: "Users",
          title: "Yhdistelmien hallinta",
          body: "Hevonen + ratsastaja yhtenä yksikkönä, tasoineen, tavoitteineen, edistymisineen ja historioineen.",
        },
        {
          icon: "ClipboardList",
          title: "Tuntimuistiinpanot & tavoitteet",
          body: "Jokaisesta tunnista muistiinpano tärkeimmistä painopistealueista, kytkettynä pitkän aikavälin tavoitteisiin.",
        },
        {
          icon: "Video",
          title: "Videopalaute",
          body: "Lataa video, merkitse hetket, lisää puhuttu tai kirjoitettu palaute.",
        },
        {
          icon: "Target",
          title: "Kilpailu- & protokolla-analyysi",
          body: "Skannaa protokollat (KNHS/FEI), katso pisteet osa-alueittain, tuomarikommentit ja trendit.",
        },
        {
          icon: "Calendar",
          title: "Suunnittelu & tuntikortit",
          body: "Kalenteri, maksut, tilaukset ja automaattiset muistutukset.",
        },
        {
          icon: "Share2",
          title: "Viestintä ratsastajalle",
          body: "Ratsastaja näkee oman sivunsa tunneilla, videoilla, tavoitteilla ja palautteella.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs muut valmentajasovellukset.",
      lead: "Jotkut valmentajatyökalut keskittyvät WhatsApp-korvaamiseen, toiset protokolla-analyysiin. EquiSight yhdistää molemmat oikealla hevosasiakirjalla — jotta ratsastaja kehittyy myös tuntien välissä.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Aloita ilmaiseksi",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Yhdistelmien hallinta",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Tuntimuistiinpanot & palaute",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Pitkän aikavälin tavoitteet",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Videolataus + palaute",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokollan skannaus",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Suorituskykyindeksi)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kilpailukalenteri",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ratsastajan portaali",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Tuntikortti / tilaus",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Verkkomaksut",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integroitu hevosasiakirja",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kengittäjä/eläinlääkäri näkyvissä",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Instruktorille JA ratsastajalle",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Useita hevosia ratsastajaa kohti",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Vertailu perustuu julkisesti saatavilla oleviin ominaisuuksiin tammikuussa 2026. EquiSight on ainutlaatuinen protokolla-analyysin + EPI:n yhdistelmässä ja integroi tämän yleiseen hevoshallintaan.",
    },
    why: {
      title: "Miksi EquiSight tarjoaa erilaisen valmentajakokemuksen.",
      lead: "Useimmat valmentajatyökalut päättyvät siihen, kun tunti loppuu. EquiSight jatkaa — hevosasiakirjassa, kilpailuanalyysissä, yhteistyössä eläinlääkärin ja omistajan kanssa.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokollan skannaus → harjoitustavoite",
          body: "Skannaa KNHS-protokolla ja näe heti, mitkä osa-alueet tarvitsevat huomiota. Tavoitteet nousevat esiin automaattisesti.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach vahvistaa silmääsi",
          body: "Useiden tuntien, kilpailujen ja protokollien data paljastaa kaavoja, joita et pysty pitämään mielessäsi.",
        },
        {
          icon: "Share2",
          title: "Integroitu hevosen kanssa",
          body: "Valmentaja näkee hevosen rokotus-, kengitys- ja vammahistorian — ei suunnitella harjoittelua toipumisen aikana.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Kouluratsastukseen ja esteratsastukseen",
      title: "Mitä valmennuskansio EquiSightissa sisältää.",
      lead: "Jokaista yhdistelmää varten saat valmennusvirran, joka pitää kaiken koossa — ei enää asioiden katoamista WhatsAppiin.",
      items: [
        "Tuntimuistiinpanot painopisteineen jokaisesta sessiosta",
        "Pitkän aikavälin tavoitteet + virstanpylväät",
        "Videolataus aikakoodikommenteilla",
        "KNHS/FEI protokollan skannaus pisteineen",
        "Tuomarikommentit kytkettynä harjoitteluun",
        "Kilpailutulokset ja EPI-trendi",
        "Asiakaskontakti ja tuntihistoria",
        "Tuntikortti / tilaus / laskut",
        "Edistymiskaavio lajeittain",
        "Jaettu pääsy hevosen omistajalle",
      ],
      ctaLabel: "Tutustu valmentajamoduuliin",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "WhatsApp + YouTubesta EquiSight Traineriin.",
      lead: "Käytännössä: näin valmennustyönkulkusi muuttuu.",
      rows: [
        {
          before: "WhatsApp irrallisilla videolinkeillä",
          after: "Video aikakoodipalautteineen asiakirjassa",
        },
        {
          before: "Muistikirja ratsastajaa kohti",
          after: "Valmennus­loki tavoitteineen + historioineen",
        },
        {
          before: "Excel kilpailupistein",
          after: "EPI-kaavio + protokolla-analyysi",
        },
        {
          before: "Suulliset tavoitteet",
          after: "Virstanpylväät edistymisindikaattoreineen",
        },
        {
          before: "Erillinen laskutustyökalu",
          after: "Tunnit + iDEAL + tilaus sovelluksessa",
        },
        {
          before: "Sähköposti omistajalle edistymisestä",
          after: "Omistaja seuraa omassa näkymässään",
        },
      ],
    },
    helper: {
      title: "Mikä valmentajasovellus sopii sinulle?",
      lead: "5 kysymystä selvittääksesi, tuoko erikoistunut valmennustyökalu lisäarvoa käytännöllesi.",
      questions: [
        {
          id: "clients",
          q: "Kuinka monta aktiivista yhdistelmää valmennat?",
          options: [
            {
              label: "Alle 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Yli 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Mikä on päälajiesi?",
          options: [
            {
              label: "Kouluratsastus",
              score: 3,
            },
            {
              label: "Esteratsastus",
              score: 2,
            },
            {
              label: "Harrastus / sekalainen",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Käytätkö videota valmennuksessa?",
          options: [
            {
              label: "Harvoin",
              score: 0,
            },
            {
              label: "Joskus (manuaalisesti)",
              score: 2,
            },
            {
              label: "Usein — järjestelmällisesti",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Valmennatko kilparatsastajia?",
          options: [
            {
              label: "Ei, harrasteita",
              score: 0,
            },
            {
              label: "Joskus kilpailuissa",
              score: 2,
            },
            {
              label: "Paljon — starttilistat keskeisiä",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Haluatko mitata valmennustasi?",
          options: [
            {
              label: "Ei, intuitio riittää",
              score: 0,
            },
            {
              label: "Kyllä, mutta ei aikaa",
              score: 2,
            },
            {
              label: "Kyllä — datapohjainen valmennus",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Yksinkertainen työkalu tai jopa WhatsApp riittää — toistaiseksi.",
          body: "Alle viidelle ratsastajalle ilman paljon videota tai kilpailuja valmennussovellus on yliampuvaa. EquiSight aloittaa ilmaiseksi, joten voit kokeilla sitä käytäntösi kasvaessa.",
          cta: "Aloita ilmaiseksi",
        },
        mid: {
          title: "EquiSight Trainer tekee sinusta järjestelmällisesti tehokkaamman.",
          body: "5–15 yhdistelmän kanssa hukkaat kuukausittain tunteja WhatsAppiin ja irrallisiin videoihin. EquiSight kokoaa kaiken yhteen, skannaa protokollat automaattisesti ja varmistaa, että ratsastajat voivat aina tarkistaa palautteensa.",
          cta: "Kokeile Trainer-moduulia",
        },
        high: {
          title: "EquiSight on rakennettu valmennuksesi mittakaavaan.",
          body: "Paljon ratsastajia, videota, kilpailuja ja datapohjainen valmennus: juuri tässä EquiSight erottuu. EPI + protokollan skannaus + hevosasiakirja antavat sinulle etumatkan, jota kilpailijoilla ei ole.",
          cta: "Sovi demo valmennuskäytännöllesi",
        },
      },
    },
    faqTitle: "Usein kysyttyjä kysymyksiä valmentajasovelluksista",
    faq: [
      {
        q: "Mikä on paras valmentajasovellus hevoselle ja ratsastajalle?",
        a: "Pelkkään viestintään riittää moni työkalu (jopa WhatsApp). Tavoitteisiin, videoanalyysiin, protokollan skannaukseen, kilpailuseurantaan ja asiakashallintaan yhdessä työkalussa EquiSight on kattavin ratkaisu — erityisesti koska se seuraa myös itse hevosta, ei pelkästään yhdistelmää.",
      },
      {
        q: "Pystyykö EquiSight lukemaan kilpailuprotokollat automaattisesti?",
        a: "Kyllä. Lataa KNHS- tai FEI-protokolla ja EquiSight poimii pisteet osa-alueittain, tuomarikommentit ja yhdistää ne yhdistelmään. Trendit näkyvät useiden kilpailujen ajalta.",
      },
      {
        q: "Mikä on EPI (Equestrian Performance Index)?",
        a: "EPI on EquiSightin pisteytysjärjestelmä, joka muuntaa useita kilpailutuloksia vertailukelpoiseksi suorituskykyindeksiksi. Näin näet todellisen edistymisen eri luokkien ja tuomareiden läpi.",
      },
      {
        q: "Voivatko ratsastajat varata tunnit itse ja maksaa ne?",
        a: "Kyllä. Ratsastajat kirjautuvat sisään, näkevät saatavilla olevat tuntiajat, ostavat tuntikortteja ja maksavat iDEAL-palvelun kautta. Sinä päätät, mitä haluat tarjota.",
      },
      {
        q: "Toimiiko se myös tallin puitteissa työskentelevän instruktorin käyttöön?",
        a: "Kyllä. Voit toimia freelance-valmentajana omilla asiakkailla ilman tallitilin yhdistämistä. Asiakkaat maksavat suoraan sinulle.",
      },
      {
        q: "Voinko siirtää olemassa olevat videot ja muistiinpanot?",
        a: "Videot voi ladata yhdistelmäkohtaisesti tai erälataustyökalun avulla. Muistiinpanot tuodaan CSV-tiedostona. Autamme aktiivisia valmentajia kertaluonteisessa siirrossa.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Oppaat ja valintaoppaat hevosenhallintaohjelmistoihin | EquiSight",
      description: "Kaikki EquiSight-oppaat yhdessä paikassa: hevosenhallinta, jalostus, tallikoulu ja valmentajaohjelmistojen vertailut sekä valintaoppaat vuodelle 2026.",
      keywords: [
        "hevosohjelmisto-oppaat",
        "hevosenhallinta valintaopas",
        "jalostussoftan vertailu",
        "tallikouluohjelmiston opas",
        "valmentajasovelluksen vertailu",
      ],
    },
    hub: {
      eyebrow: "Keskus · oppaat",
      breadcrumbLabel: "Oppaat",
      title: "Neljä kattavaa opasta oikean hevosohjelmiston valintaan.",
      intro: "Jokaiselle kohderyhmälle syvällinen valintaopas: vertailutaulukot, kriteerit, esimerkit ja interaktiivinen testi. Siirry sinulle sopivaan oppaaseen tai tutustu ensin kunkin kokonaisuuden syventäviin artikkeleihin.",
      stats: {
        guides: "4 valintaopasta",
        articles: "15 syventävää artikkelia",
        fair: "Reilu vertailu",
      },
      readMoreCta: "Lue koko opas",
      relatedHeading: "Syventävät artikkelit",
      articlesCountSingular: "{{count}} syventävä artikkeli",
      articlesCountPlural: "{{count}} syventävää artikkelia",
      articlesCountAria: "Kokonaisuuden artikkelien määrä",
      lastUpdatedPrefix: "Päivitetty",
      lastUpdatedAria: "Tämän kokonaisuuden viimeisimmän päivityksen päivämäärä",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Hevosenhallintasovelluksen valintaopas",
        blurb: "Vertaile tunnetuimpia hevosenhallintasovelluksia ja selvitä, mikä sopii omistajalle, tallille tai jalostukselle. Sisältää reilun vertailutaulukon ja 5 kysymyksen valintaoppaan.",
        audience: "Omistajille, tallinpitäjille ja kaikille hevosihmisille, jotka haluavat selkeyttä.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Jalostussoftware-vertailu",
        blurb: "Tamman kiimakierrosta varsan kehitykseen: katso, mikä jalostussoftware toimii oikeasti tammojesi määrän, jalostustavan ja kantakirjavaatimusten mukaan.",
        audience: "Harrastus- ja ammattijalostaville, hevostilallisille ja oriinomistajille.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Tallikouluohjelmiston valintaopas",
        blurb: "Tuntisuunnittelu, ratsastajarekisteri, omistajaportaali ja laskutus — yhdessä työkalussa. Vertaile vaihtoehtoja tallikouluille ja täysihoitotalleille vuodelle 2026.",
        audience: "Tallikouluille, täysihoitotalleille ja ratsastusyrityksille.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Valmentajasovelluksen valintaopas",
        blurb: "Coaching-CRM, videopalaute, KNHS-protokollan skannaus ja tavoitteet jokaiselle hevos-ratsastaja-parille. Mikä valmentajasovellus sopii sinun valmennuskäytäntöösi?",
        audience: "Ohjaajille, valmentajille ja coacheille.",
      },
    ],
    closing: {
      eyebrow: "Miksi nämä oppaat",
      title: "Reilu vertailu — ei pelkkiä hintoja.",
      body1: "Monet \"vertailusivut\" ovat piilomainoksia. Oppaamme asettavat toiminnot, kohderyhmän ja kilpailijat rinnakkain kuten riippumaton tietolähde tekisi. EquiSight nousee luonnollisesti esiin kattavana ratkaisuna, mutta luet myös rehellisesti, missä muut sovellukset ovat vahvempia.",
      body2: "Kunkin oppaan syventävät artikkelit vastaavat konkreettisiin kysymyksiin, jotka nousevat valinnan yhteydessä: \"Milloin ensimmäinen ultraääni siemennyksen jälkeen\", \"Kuinka automatisoin tallikoulun laskutuksen\", \"Kuinka analysoin kilpailuprotokollan\". Ei markkinointijargonia, vaan käytännön tietoa.",
    },
    hubName: "EquiSight-oppaat",
  },
  ui: {
    sectionEyebrows: {
      pains: "Miksi tämä on ongelma",
      basics: "Perusteet",
      criteria: "Mikä tekee siitä hyvän?",
      comparison: "Reilu vertailu",
      why: "Ero",
      beforeAfter: "Hajanaisuudesta selkeään kokonaiskuvaan",
      helper: "5 kysymystä",
    },
    table: {
      feature: "Ominaisuus",
      today: "Tänään",
      withEquisight: "EquiSightin kanssa",
    },
    helper: {
      questionLabel: "Kysymys {{current}} / {{total}}",
      answerPrompt: "Vastaa {{count}} jäljellä olevaan kysymykseen nähdäksesi suosituksen.",
      answerPromptPlural: "Vastaa {{count}} jäljellä olevaan kysymykseen nähdäksesi suosituksen.",
      resultEyebrow: "Sinun tuloksesi",
    },
    targetGroupsFallback: "Kenelle tämä on tarkoitettu?",
    faqTitleFallback: "Usein kysytyt kysymykset",
  },
};

export default CORNERSTONES;
